/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_History_EarlierInputs */



/**
* | output |
* | --- |
* | "Earlier" |
*
* @param {Chat_History_EarlierInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_history_earlier = /** @type {((inputs?: Chat_History_EarlierInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_History_EarlierInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Eerder")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus tôt")
	return /** @type {LocalizedString} */ ("Earlier")
});